<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import concept from "@/models/modelosDeLiquidacion/Relations/concept";
import concepts from "@/store/conceptos/concepts";
import Vue from "vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("nav.concepts"),
      titleTable: "ModelosDeLiquidacion_Conceptos",
      titleDelete: this.$tc("modelsLiquidations.toConceptToLiquidation"),
      isLoading: true,
      maxWidth: ["550px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Autoriza",
          value: "fixedTable",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      selectAutoriza: [
        {
          name: "No autoriza",
          value: 0,
        },
        {
          name: "Autoriza",
          value: 1,
        },
        {
          name: "Según autorización previa",
          value: 2,
        },
      ],
    };
  },

  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await concepts.dispatch("getConcepts");
    this.isLoading = false;
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !modelsLiquidation.state.edit.conceptos ||
        modelsLiquidation.state.edit.conceptos.length === 0
      ) {
        return []; // Return an empty array when conceptos doesn't exist or is falsy
      } else {
        return modelsLiquidation.state.edit.conceptos?.map((item) => {
          return concept.fromJson(item);
        });
      }
    },

    concepts() {
      return concepts.state.concepts;
    },

    conceptsSelected() {
      const editConcepts = this.editConcepts;
      return concepts.state.concepts.filter(
        (concept) =>
          !editConcepts?.some(
            (selected) => selected.conceptoId === concept.conceptId
          )
      );
    },
    editConcepts() {
      return modelsLiquidation.state.edit.conceptos;
    },

    dataSelects() {
      return [
        {
          name: "idAutorizacion",
          label: "Autorizacion",
          data: "",
          items: [],
          itemsValue: "value",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
        },
        {
          name: "idConcept",
          label: "Concepto",
          data: "",
          items: [],
          itemsValue: "conceptId",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },

    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    editConcept(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.liqModeloId = modelsLiquidation.state.edit.id;

        modelsLiquidation.commit("setEditRelation", payload);
        modelsLiquidation
          .dispatch("editConcept")
          .then(() => {
            this.showAlert(
              this.$tc("modelsLiquidations.editConceptToLiquidationSuccess"),
              "#82A1D0"
            );
          })
          .catch((e) => {
            this.showAlert(
              this.$tc("costCenter.addCostCenterError"),
              "#ff8d58"
            );
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }
      this.reset(false);
    },
    detectChanges(newItems) {
      const changes = {};
      const oldItem = this.oldItems;
      if (oldItem.fixed !== Number(newItems.idAutorizacion)) {
        changes.autoriza = newItems.idAutorizacion;
        changes.id = oldItem.id;
      }
      return changes;
    },

    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].data = this.selectAutoriza[0].value;
          this.dataSelects[0].items = this.selectAutoriza;
          this.dataSelects[1].items = this.conceptsSelected;
          this.dataSelects[1].readonly = false;

          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.addConceptToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.oldItems = item;
          this.dataSelects[0].data = item.fixed;
          this.dataSelects[0].items = this.selectAutoriza;
          this.dataSelects[1].data = item.id;
          this.dataSelects[1].items = this.concepts;
          this.dataSelects[1].readonly = true;
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editConceptToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            liqModeloId: modelsLiquidation.state.edit.id,
          };
          break;
        default:
          break;
      }
    },

    reset(value) {
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.dataSelects.forEach((item) => {
        item.data = "";
        item.items = [];
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addConcept(items);
          break;
        case "edit":
          this.editConcept(items);
          break;
        default:
          break;
      }
    },

    async addConcept(form) {
      let payload = {
        ...form,
        liqModeloId: modelsLiquidation.state.edit.id,
      };
      modelsLiquidation.commit("setNew", payload);
      modelsLiquidation
        .dispatch("addConcept")
        .then(() => {
          concepts.dispatch("getConcepts");
          this.showAlert(
            this.$tc("modelsLiquidations.addConceptToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.errorInstance"),
            "#ff8d58"
          );
        });
      this.reset(false);
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteConcept")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("modelsLiquidations.deleteConceptToLiquidationSuccess"),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationError"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
